import React from "react";
import CollapseFiltersContainer from "Containers/CollapseFiltersContainer";
import { Label } from "ComponentsUI/TextField";
import { SortPanel } from "ComponentsUI/Sort";
import { FiltersLayout, FiltersItem } from "ComponentsUI/Filters";
import withStyles from "react-jss";
import OrientationChanger from "ComponentsUI/OrientationChanger";

const styles = (theme) => ({
	stub: {
		height: "50px",
		width: "100%",
		borderRadius: "10px",
		backgroundColor: theme.palette.colors.disabled,
	},
});

class FiltersStub extends React.Component {
	generateStub() {
		let classes = this.props.classes;
		let array = [];
		for (let i = 0; i < this.props.amount; i++) {
			array.push(
				<FiltersItem key={i}>
					<Label stub={true} />
					<div className={classes.stub} />
				</FiltersItem>
			);
		}
		return array;
	}

	generateSort() {
		let sortItems = [
			{
				key: "date",
				name: null,
			},
		];
		let selectedSort = { item: { key: "date" } };

		let orientationChanger = !this.props.withoutSwitchers ? (
			<OrientationChanger onChange={() => {}} stub={true} flat={false} />
		) : null;

		return <SortPanel stub={true} orientationChanger={orientationChanger} />;
	}

	render() {
		return (
			<React.Fragment>
				<FiltersLayout>
					<CollapseFiltersContainer isProviderCard={this.props.isProviderCard}>
						{this.generateStub()}
					</CollapseFiltersContainer>
				</FiltersLayout>
				{this.props.sort && this.generateSort()}
			</React.Fragment>
		);
	}
}

export default withStyles(styles)(FiltersStub);
